<div class="grid">
    <ag-grid-angular
        [style.width]="'100%'"
        [style.height]="domLayout() === 'autoHeight' ? 'auto' : height()"
        class="ag-theme-quartz"
        [gridOptions]="gridOptions()"
        [rowData]="rowData()"
        [columnDefs]="columnDefs()"
        [autoSizeStrategy]="autoSizeStrategy()"
        [theme]="theme()"
    ></ag-grid-angular>
</div>
